import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { PopoverComponent } from '../popover/popover.component'
import { Router } from '@angular/router';
import { faBars, faGear } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit {
  public faBars: any;
  public faGear: any;
  constructor(public popoverController: PopoverController,  public router: Router) {
    this.faBars = faBars;
    this.faGear = faGear;

  }

  ngOnInit() {
    this.collappseMenu()
  }

  collappseMenu() {
    let listButtonMenu = document.querySelectorAll('.buttonMenu')
    listButtonMenu.forEach(item => {
      item.addEventListener('click', () => {
        let listContainerPage = document.querySelectorAll('.containerPage')
        listContainerPage.forEach(e => e.classList.toggle('active'))
      })
    })
  }

  async presentPopover(ev: any) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: ev,
      translucent: true
    });
    await popover.present();
  }
}
